<script lang="ts">
	import Link from "./Link.svelte";
	import type { Breadcrumb } from "../../../core/schema/Breadcrumb.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import arrowLeftLong from "../../../core/assets/icons/arrow-left-long.svg?raw";
	import translations from "./Breadcrumbs.translations.json";
	import Icon from "./Icon.svelte";
	import { getSharedTranslate } from "../utils/getSharedTranslate.js";

	export let pageSlug: string;
	export let breadcrumbs: Breadcrumb[];

	const translate = getSharedTranslate(translations);

	const breadcrumbsBackUrl = breadcrumbs.length > 1 && breadcrumbs[breadcrumbs.length - 2]?.url;
</script>

{#if breadcrumbs.length > 0}
	<nav class="hidden py-4 md:container md:block md:py-8 lg:px-8">
		<div class="flex justify-between gap-6">
			<ul class="font-spaceMono flex flex-1 items-center gap-2.5 overflow-x-auto">
				{#each breadcrumbs as { url, label }, index}
					<li>
						<Link
							class="text-2xs flex gap-2.5 text-nowrap leading-loose !text-black !decoration-black md:text-xs"
							href={url}
							noUnderline={url !== `/${pageSlug}`}
						>
							<span>
								{nbspify(label)}
							</span>
						</Link>
					</li>
					{#if index < breadcrumbs.length - 1}
						<li class="text-theme text-xs leading-loose">/</li>
					{/if}
				{/each}
			</ul>
			{#if breadcrumbsBackUrl}
				<Link
					class="hidden gap-2.5 text-nowrap text-xs leading-loose !text-black !decoration-black md:!flex"
					href={breadcrumbsBackUrl}
					noUnderline
				>
					<Icon icon={arrowLeftLong} class="text-theme" />
					<span>{translate("back")}</span>
				</Link>
			{/if}
		</div>
	</nav>
{/if}
